module.exports = __webpack_public_path__ + "static/media/QR_Code.d0a2975c.jpg";